// Последнее выбранное ООО — удобство на этом устройстве (показатели, планы).
// Без него ООО выбирают явно: значения одного ООО не должны молча попасть в другое.
import type { Catalog, Me } from './api';
import { defaults } from './session';

const KEY = 'mis.metrics.legalEntity';

export function initialLe(me: Me | null, catalog: Catalog | null): string | null {
  const ids = catalog?.legalEntities.map((l) => l.id) ?? [];
  const def = defaults(me).legalEntityId;
  if (def) return def;
  if (ids.length === 1) return ids[0];
  let last: string | null = null;
  try {
    last = localStorage.getItem(KEY);
  } catch {
    last = null;
  }
  return last && ids.includes(last) ? last : null;
}

export function rememberLe(id: string) {
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* хранилище недоступно — выберут ещё раз */
  }
}
